/**
 * Simplified disclaimer service
 * This is a replacement for the deleted service to fix the build error
 */

export const disclaimerService = {
  /**
   * Check if a user has acknowledged the disclaimer
   * @param {string} userEmail - The user's email
   * @returns {Promise<boolean>} - Whether the user has acknowledged the disclaimer
   */
  checkDisclaimerAcknowledgment: async (userEmail) => {
    // Check localStorage for acknowledgment
    const key = `disclaimer_${userEmail}`;
    const acknowledged = localStorage.getItem(key) === 'true';
    return acknowledged;
  },

  /**
   * Record that a user has acknowledged the disclaimer
   * @param {string} userEmail - The user's email
   * @returns {Promise<void>}
   */
  recordDisclaimerAcknowledgment: async (userEmail) => {
    // Store acknowledgment in localStorage
    const key = `disclaimer_${userEmail}`;
    localStorage.setItem(key, 'true');
    return true;
  }
};
